export default __webpack_public_path__ + "static/media/ID_SCHOOL_BOBY.ea64a21d.jpg";